var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolarDangerTriangleBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FFE9E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0843 21.3493C18.975 14.4493 20.9203 11 24.0016 11C27.083 11 29.0283 14.4493 32.919 21.3493L33.4043 22.208C36.6376 27.9413 38.255 30.808 36.7936 32.904C35.3323 35 31.7163 35 24.487 35H23.5163C16.287 35 12.671 35 11.2096 32.904C9.74829 30.808 11.3656 27.9413 14.599 22.208L15.0843 21.3493ZM24.0016 16.6667C24.2668 16.6667 24.5212 16.772 24.7087 16.9596C24.8963 17.1471 25.0016 17.4015 25.0016 17.6667V24.3333C25.0016 24.5985 24.8963 24.8529 24.7087 25.0404C24.5212 25.228 24.2668 25.3333 24.0016 25.3333C23.7364 25.3333 23.4821 25.228 23.2945 25.0404C23.107 24.8529 23.0016 24.5985 23.0016 24.3333V17.6667C23.0016 17.4015 23.107 17.1471 23.2945 16.9596C23.4821 16.772 23.7364 16.6667 24.0016 16.6667ZM24.0016 29.6667C24.3552 29.6667 24.6944 29.5262 24.9444 29.2761C25.1945 29.0261 25.335 28.687 25.335 28.3333C25.335 27.9797 25.1945 27.6406 24.9444 27.3905C24.6944 27.1405 24.3552 27 24.0016 27C23.648 27 23.3089 27.1405 23.0588 27.3905C22.8088 27.6406 22.6683 27.9797 22.6683 28.3333C22.6683 28.687 22.8088 29.0261 23.0588 29.2761C23.3089 29.5262 23.648 29.6667 24.0016 29.6667Z",
    fill: "#CA1C22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarDangerTriangleBold);
export default __webpack_public_path__ + "static/media/solar_danger-triangle-bold.eef08de0ed4e8d5113bdec6ec6ddff24.svg";
export { ForwardRef as ReactComponent };